module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "route-list-selector"
  }, [_c('div', {
    staticClass: "route-list-selector-btn-container"
  }, [_c('md-button', {
    staticClass: "md-accent md-dense",
    on: {
      "click": _vm.cancelSelect
    }
  }, [_vm._v("Отмена")])], 1), _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "route-list-selector-container"
  }, [_c('sort-table', {
    ref: "table",
    staticClass: "route-selector-table",
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.count,
      "total": _vm.amount,
      "table-id": "route-selector-table",
      "showAddButton": false,
      "loadOnScroll": false,
      "pageFromQuery": false,
      "cursor": "pointer"
    },
    on: {
      "refresh": _vm.getItineraries,
      "item-click": _vm.onItemClick
    },
    scopedSlots: _vm._u([{
      key: "freights",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s((scope.item.freights) ? scope.item.freights.length : ((scope.item.freights_ids) ? scope.item.freights_ids.length : 0)))]
      }
    }, {
      key: "forwarder",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.item.forwarder !== null ? scope.item.forwarder.login : ''))]
      }
    }, {
      key: "from_stock",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.item.from_stock ? scope.item.from_stock.name : 'Не установлен'))]
      }
    }, {
      key: "to_stock",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.item.to_stock ? scope.item.to_stock.name : 'Не установлен'))]
      }
    }, {
      key: "date",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.item.date ? _vm.moment(scope.item.date).format('DD.MM.YYYY') : 'Не установленна'))]
      }
    }, {
      key: "weight",
      fn: function(scope) {
        return [(scope.item.weight) ? _c('span', [_vm._v(_vm._s(scope.item.weight.toFixed(2)))]) : _c('span', [_vm._v("Не указан")])]
      }
    }, {
      key: "size",
      fn: function(scope) {
        return [(scope.item.size) ? _c('span', [_vm._v(_vm._s(scope.item.size.toFixed(2)))]) : _c('span', [_vm._v("Не указан")])]
      }
    }, {
      key: "status",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "itineraries-status",
          style: (('color: ' + scope.item.status.color + ';'))
        }, [_c('span', [_vm._v(_vm._s(scope.item.status.message))])])]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return [_c('md-button', {
          staticClass: "md-icon-button md-dense small",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onItemClick(scope)
            }
          }
        }, [_c('md-icon', [_vm._v("add")])], 1)]
      }
    }]),
    model: {
      value: (_vm.routeLists),
      callback: function($$v) {
        _vm.routeLists = $$v
      },
      expression: "routeLists"
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b16ae98","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RouteListSelector.vue
// module id = 1089
// module chunks = 0